import Box from '@redbubble/design-system/src/Box';
import AlertIcon from '@redbubble/design-system/src/Icons/Alert';
import List, { ListItem } from '@redbubble/design-system/src/List';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { UserInfo } from '@redbubble/next-analytics';
import { useUserInfo } from '@redbubble/next-provider';

import { useDeferredValue } from 'react';
import { useCurrentInventoryStore } from '../../hooks/useCurrentInventoryItem';
import styles from './ComplianceLinks.module.scss';

const helpCenterBaseUrl = 'https://help.redbubble.com/hc/';
const helpCentreArticle = '201579195';

export const messages = defineMessages({
  reportContent: {
    defaultMessage: 'Report Content',
  },

  copyrightInfringement: {
    defaultMessage: 'Copyright Infringement Policy',
  },
});

export const ComplianceLinks: React.FC = () => {
  const intl = useIntl();
  const [{ locale }] = useUserInfo<UserInfo>();

  const workId = useCurrentInventoryStore(
    (state) => state.currentInventoryItem.workId
  );

  const workID = useDeferredValue(workId);

  const links = [
    {
      label: intl.formatMessage(messages.reportContent),
      href: `/objections/add/${workID}?content_type=ImageWork`,
    },

    {
      label: intl.formatMessage(messages.copyrightInfringement),
      href: `${helpCenterBaseUrl}${locale}/articles/${helpCentreArticle}`,
    },
  ];

  return (
    <>
      <Box className={[styles.container, styles.desktop].join(' ')}>
        <List className={styles.list}>
          <ListItem className={styles.icon}>
            <AlertIcon size="medium" />
          </ListItem>

          {links.map(({ label, href }) => (
            <ListItem
              key={label}
              className={styles.listItem}
              element="a"
              href={href}
              target="_blank"
              rel="nofollow"
            >
              {label}
            </ListItem>
          ))}
        </List>
      </Box>

      <Box className={[styles.container, styles.mobile].join(' ')}>
        <List relaxed className={styles.list}>
          {links.map(({ label, href }) => (
            <ListItem
              key={label}
              className={styles.listItem}
              element="a"
              href={href}
              target="_blank"
              rel="nofollow"
              arrow
            >
              {label}
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};
